import { isGPReportListEnabled } from "./infra/featureToggle";
import { WORKFLOW_APPT_STATUS_OPTIONS_BY_HOSPITAL, getCategoryOptions } from "./configurableConst";

export const DAYS_OF_WORK = [
  {
    label: "Monday",
    value: 1,
  },
  {
    label: "Tuesday",
    value: 2,
  },
  {
    label: "Wednesday",
    value: 3,
  },
  {
    label: "Thursday",
    value: 4,
  },
  {
    label: "Friday",
    value: 5,
  },
];

export const serviceBenefitsMapping = {
  132: {
    id: "132",
    benefit: "234.85",
    extraId: "112",
    extraBenefit: "117.45",
  },
  110: {
    id: "110",
    benefit: "134.30",
    extraId: "112",
    extraBenefit: "67.15",
  },
  113: {
    id: "113",
    benefit: "115.80",
    extraId: "112",
    extraBenefit: "57.90",
  },
  116: { id: "116", benefit: "67.20", extraId: "112", extraBenefit: "33.60" },
  291: {
    id: "291",
    benefit: "402.75",
    extraId: "288",
    extraBenefit: "201.40",
  },
  296: {
    id: "296",
    benefit: "231.65",
    extraId: "288",
    extraBenefit: "115.85",
  },
  141: {
    id: "141",
    benefit: "402.75",
    extraId: "149",
    extraBenefit: "201.40",
  },
  104: { id: "104", benefit: "76.15", extraId: "99", extraBenefit: "38.1" },
  105: { id: "105", benefit: "38.25", extraId: "99", extraBenefit: "19.15" },
  133: {
    id: "133",
    benefit: "117.60",
    extraId: "112",
    extraBenefit: "58.80",
  },
  293: {
    id: "293",
    benefit: "251.80",
    extraId: "288",
    extraBenefit: "125.90",
  },
  143: {
    id: "143",
    benefit: "251.80",
    extraId: "149",
    extraBenefit: "125.90",
  },
  304: {
    id: "304",
    benefit: "118.45",
    extraId: "288",
    extraBenefit: "59.25",
  },
  306: {
    id: "306",
    benefit: "163.50",
    extraId: "288",
    extraBenefit: "81.75",
  },
  6007: {
    id: "6007",
    benefit: "115.35",
    extraId: "6016",
    extraBenefit: "57.70",
  },
  91824: {
    id: "91824",
    benefit: "134.30",
    extraId: "",
    extraBenefit: "",
  },
  92162: {
    id: "92162",
    benefit: "402.75",
    extraId: "",
    extraBenefit: "",
  },
  91825: {
    id: "91825",
    benefit: "67.20",
    extraId: "",
    extraBenefit: "",
  },
  "92162 COVID19": {
    id: "91824",
    benefit: "466.80",
    extraId: "",
    extraBenefit: "",
  },
  91833: {
    id: "91833",
    benefit: "38.25",
    extraId: "",
    extraBenefit: "",
  },
  91822: {
    id: "91822",
    benefit: "76.15",
    extraId: "",
    extraBenefit: "",
  },
  92435: {
    id: "92435",
    benefit: "402.75",
    extraId: "",
    extraBenefit: "",
  },
  91835: {
    id: "91835",
    benefit: "67.20",
    extraId: "",
    extraBenefit: "",
  },
  92432: {
    id: "92432",
    benefit: "117.60",
    extraId: "",
    extraBenefit: "",
  },
  92422: {
    id: "92422",
    benefit: "234.85",
    extraId: "",
    extraBenefit: "",
  },
  91170: {
    id: "91170",
    benefit: "87.45",
    extraId: "",
    extraBenefit: "",
  },
  92423: {
    id: "92423",
    benefit: "117.60",
    extraId: "",
    extraBenefit: "",
  },
  92431: {
    id: "92431",
    benefit: "234.85",
    extraId: "",
    extraBenefit: "",
  },
  92436: {
    id: "92436",
    benefit: "251.80",
    extraId: "",
    extraBenefit: "",
  },
  93000: {
    id: "93000",
    benefit: "54.60",
    extraId: "",
    extraBenefit: "",
  },
  91834: {
    id: "91834",
    benefit: "134.30",
    extraId: "",
    extraBenefit: "",
  },
  91828: {
    id: "91828",
    benefit: "76.95",
    extraId: "",
    extraBenefit: "",
  },
  91184: {
    id: "91184",
    benefit: "87.45",
    extraId: "",
    extraBenefit: "",
  },
  93013: {
    id: "93013",
    benefit: "54.60",
    extraId: "",
    extraBenefit: "",
  },
  92140: {
    id: "92140",
    benefit: "234.85",
    extraId: "",
    extraBenefit: "",
  },
  92437: {
    id: "92437",
    benefit: "231.65",
    extraId: "",
    extraBenefit: "",
  },
  92442: {
    id: "92442",
    benefit: "234.85",
    extraId: "",
    extraBenefit: "",
  },
  92610: {
    id: "92610",
    benefit: "115.35",
    extraId: "",
    extraBenefit: "",
  },
  91823: {
    id: "91823",
    benefit: "38.25",
    extraId: "",
    extraBenefit: "",
  },
};

// Only supervisors may reach the global secure files page. Kept as a named
// constant so the tab, the route guard and any future caller share one list.
export const GLOBAL_SECURE_FILES_ROLES = ["TELECARE_SUPERVISOR"];

export const tabs = [
  { id: "workflow", label: "WORKFLOW", path: "client-appointment" },
  { id: "archived-workflow", label: "ARCHIVED WORKFLOW", path: "archived-client-appointment" },
  { id: "history-workflow", label: "HISTORY WORKFLOW", path: "history-client-appointment" },
  { id: "settings", label: "SETTINGS", path: "settings" },
  { id: "my_todo_list", label: "MY TODO LIST", path: "my-todo-list" },
  // { id: "apt_requests", label: "APT REQUESTS", path: "apt-requests" },
  // { id: "live_appointments", label: "LIVE APPOINTMENTS", path: "live-appointments" },
  { id: "specialists", label: "SPECIALISTS", path: "specialists" },
  { id: "schedule", label: "SCHEDULE", path: "schedule" },
  { id: "referral_inbox", label: "REFERRAL INBOX", path: "referral-inbox" },
  { id: "error_results_inbox", label: "ABNORMAL RESULTS INBOX", path: "error-results-inbox" },
  { id: "error_reports_inbox", label: "GP REPORT UPLOAD", path: "error-reports-inbox" },
  {
    id: "global_secure_files",
    label: "SECURE FILES",
    path: "secure-files",
    permittedRoles: GLOBAL_SECURE_FILES_ROLES,
  },
];

export const aptRequestClientTab = [
  { id: "logs", label: "SMS Logs", enabled: true },
  { id: "sms", label: "Send SMS", enabled: true },
  { id: "email", label: "Send Email", enabled: true },
];

export const workflowClientTab = [
  { id: "logs", label: "SMS Logs", enabled: true },
  { id: "sms", label: "Send SMS", enabled: true },
  { id: "email", label: "Send Email", enabled: true },
  { id: "history", label: "History", enabled: true },
  { id: "todos", label: "Todo List", enabled: true },
  { id: "activity", label: "Activity", enabled: true },
  { id: "gp_reports", label: "Outbound Letters", enabled: isGPReportListEnabled },
  { id: "secure_files", label: "Secure File", enabled: true },
];

export const nameTitles = [
  { label: "Acs Prof", value: "Asc Prof" },
  { label: "Dr", value: "Dr" },
  { label: "Master", value: "Master" },
  { label: "Miss", value: "Miss" },
  { label: "Mr", value: "Mr" },
  { label: "Mrs", value: "Mrs" },
  { label: "Ms", value: "Ms" },
  { label: "Prof", value: "Prof" },
  { label: "Rev", value: "Rev" },
  { label: "Sir", value: "Sir" },
];

export const auStates = [
  { label: "New South Wales", value: "NSW" },
  { label: "Victoria", value: "VIC" },
  { label: "Queensland", value: "QLD" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Tasmania", value: "TAS" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "Northern Territory", value: "NT" },
];

// Base — the standard options used as the dropdown default across hospitals.
const _DEFAULT_OPTIONS = [
  { label: "Audit", value: "adminAudit" },
  { label: "Booked", value: "booked" },
  { label: "Check Out", value: "checkOut" },
  { label: "Discharged", value: "discharged" },
  { label: "Expired", value: "expiredReferral" },
  { label: "FTA", value: "fta" },
  { label: "FTA Rebook", value: "ftaRebook" },
  { label: "FTA Removed", value: "ftaRemoved" },
  { label: "F2F Transfer", value: "f2fTransfer" },
  { label: "Late Cancel", value: "lateCancel" },
  { label: "NRFC", value: "nrfc" },
  { label: "Removed", value: "remove" },
  { label: "Relocated", value: "relocated" },
  { label: "To Book", value: "awaitingBooking" },
];

// Extended — legacy / other-hospital statuses for display & filter recognition,
// but NOT in the default options dropdown.
const _EXTENDED = [
  { label: "DNA", value: "dna" },
  { label: "DNA Rebook", value: "dnaRebook" },
  { label: "DNA Removed", value: "dnaRemoved" },
];

// Full list for display / filter lookup = default + extended.
export const WORKFLOW_APPT_STATUS = [..._DEFAULT_OPTIONS, ..._EXTENDED];

export const WORKFLOW_APPT_STATUS_OPTIONS =
  WORKFLOW_APPT_STATUS_OPTIONS_BY_HOSPITAL[process.env.REACT_APP_HOSPITAL_NAME] || _DEFAULT_OPTIONS;

export const WORKFLOW_STATUS = [
  { label: "attended", value: "attended" },
  { label: "rescheduled", value: "rescheduled" },
  { label: "no show", value: "noShow" },
  { label: "cancelled", value: "cancelled" },
];

export const COLLECTIONS = {
  SPECIALIST_AVAILABLE_DATETIME: "specialist_available_datetime",
  SPECIALISTS_COLLECTION: "specialists",
  CLIENT_APPOINTMENTS: "client_appointments",
  CLIENT_APPOINTMENTS_REQUESTS: "client_appointment_requests",
};

export const TIME_FORMAT = {
  TIME_WITH_TZ: "YYYY-MM-DDTHH:mm:ss Z",
  MONTH: "YYYYMM",
  MONTH_WITH_DASH: "YYYY-MM",
  HOUR_AND_MIN: "HH:mm",
  DATE: "YYYYMMDD",
  DATE_WITH_DASH: "YYYY-MM-DD",
  DATE_WITH_TIME: "YYYYMMDDHH:mm",
  HOUR_MIN_SEC: "HH:mm:ss",
};

export const STATUS = {
  DEFAULT: "DEFAULT",
  LOADING: "LOADING",
  SUCCEED: "SUCCEED",
  FAILED: "FAILED",
};

export const userRoles = [
  { label: "ADMIN", value: "TELECARE_ADMIN" },
  { label: "GP", value: "GP" },
  { label: "CLINIC_ADMIN", value: "CLINIC_ADMIN" },
  { label: "IT", value: "TELECARE_IT" },
  { label: "SPECIALIST", value: "SPECIALIST" },
  { label: "SUPERVISOR", value: "TELECARE_SUPERVISOR" },
];

export const getLabelByValue = (value) => {
  const role = userRoles.find((role) => role.value === value);
  return role ? role.label : undefined;
};

export const timezones = [
  { label: "Australia/Canberra", value: "Australia/Canberra" },
  { label: "Australia/Sydney", value: "Australia/Sydney" },
  { label: "Australia/Darwin", value: "Australia/Darwin" },
  { label: "Australia/Brisbane", value: "Australia/Brisbane" },
  { label: "Australia/Adelaide", value: "Australia/Adelaide" },
  { label: "Australia/Hobart", value: "Australia/Hobart" },
  { label: "Australia/Melbourne", value: "Australia/Melbourne" },
  { label: "Australia/Perth", value: "Australia/Perth" },
  { label: "Australia/Broken_Hill", value: "Australia/Broken_Hill" },
  { label: "Australia/Currie", value: "Australia/Currie" },
  { label: "Australia/Eucla", value: "Australia/Eucla" },
  { label: "Australia/Lord_Howe", value: "Australia/Lord_Howe" },
  { label: "Australia/Lindeman", value: "Australia/Lindeman" },
  { label: "Indian/Christmas", value: "Indian/Christmas" },
  { label: "Indian/Cocos", value: "Indian/Cocos" },
  { label: "Pacific/Norfolk", value: "Pacific/Norfolk" },
];

export const SMS_TEMPLATES_ORDER_ARRAY = ["Own Device", "Mackay Base Hospital"];

export const TITLES = ["Acs Prof", "Dr", "Master", "Miss", "Mr", "Mrs", "Re"];

export const TITLE_OPTIONS = TITLES.map((title) => ({ label: title, value: title }));

export const STATES = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];

export const STATES_OPTIONS = STATES.map((state) => ({ label: state, value: state }));

export const EXPIRY_DATE_BY_MONTH = [
  { label: "3 months", value: "3" },
  { label: "12 months", value: "12" },
  { label: "Indefinite", value: "0" },
];

// Per-hospital — see CATEGORY_OPTIONS_BY_HOSPITAL in configurableConst.ts.
export const CATEGORY_OPTIONS = getCategoryOptions(process.env.REACT_APP_HOSPITAL_NAME);

export const WEEKS_TO_APPOINTMENT_OPTIONS = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "16", value: "16" },
  { label: "24", value: "24" },
  { label: "36", value: "36" },
  { label: "52", value: "52" },
];

export const APPOINTMENT_TYPE = {
  AT_HOME: "atHome",
  AT_GP_CLINIC: "atGpClinic",
  AGE_CARE: "ageCare",
  F2F: "f2f",
};

export const AUTO_SMS_KEY = {
  INITIAL: "initial",
  INITIAL_SECOND: "initialSecond",
  INITIAL_THIRD: "initialThird",
  SECOND: "second",
  THIRD: "third",
  FOURTH: "fourth",
};

export const MELBOURNE_TIMEZONE = "Australia/Melbourne";
// The zone appointments are booked and displayed in for this tenant. Every
// current tenant is a single-state service, so one zone per deployment is
// right; what was wrong was letting each coordinator's laptop supply it.
export const DEFAULT_TIMEZONE = process.env.REACT_APP_DEFAULT_TIMEZONE || "Australia/Brisbane";

export const TIMEOUT = 120 * 60 * 1000;
// Tells the API the tab is still open. The API expires a session 15 minutes
// after the last ping it received, so at 5 minutes two failed pings in a row
// signed the user out. Every minute, a connection has to be down for about
// 14 minutes before that happens.
export const USER_ACTIVITY_HEARTBEAT_INTERVAL = 60 * 1000;
// How long the WORKFLOW listener may go without its first snapshot before the
// page says so. A healthy connection delivers it in a few seconds.
export const FIRST_SNAPSHOT_TIMEOUT_MS = 15 * 1000;

export const SCOPE = {
  LOGIN: "LOGIN",
  VIEW_ALL_TODOS: "VIEW_ALL_TODOS",
  CLIENT_SETTING: "CLIENT_SETTING",
  OTHER_SETTINGS: "OTHER_SETTINGS",
};

export const ROLE_ACCESSIBILITY = {
  TELECARE_SUPERVISOR: [SCOPE.LOGIN, SCOPE.VIEW_ALL_TODOS, SCOPE.CLIENT_SETTING, SCOPE.OTHER_SETTINGS],
  TELECARE_ADMIN: [SCOPE.LOGIN],
  TELECARE_IT: [SCOPE.LOGIN, SCOPE.VIEW_ALL_TODOS, SCOPE.CLIENT_SETTING, SCOPE.OTHER_SETTINGS],
};

export const ADMIN_ROLE = ["TELECARE_ADMIN", "TELECARE_SUPERVISOR"];

export const CLIENT_APPOINTMENTS = [
  "adminAudit",
  "awaitingBooking",
  "expiredReferral",
  "ftaRebook",
  "nrfc",
  "booked",
  "NS",
  "dnaRebook",
];

export const ARCHIVED_CLIENT_APPOINTMENTS = [
  "ftaRemoved",
  "remove",
  "relocated",
  "discharged",
  "f2fTransfer",
  "lateCancel",
  "dnaRemoved",
];

export const HISTORY_CLIENT_APPOINTMENTS = ["checkOut", "fta", "dna"];

export const APPOINTMENT_STATUS_TO_ARCHIVE = ARCHIVED_CLIENT_APPOINTMENTS.concat(HISTORY_CLIENT_APPOINTMENTS);

export const ROUTE_PATHS = {
  ACTIVE_WORKFLOW: "/admin/client-appointment",
  HISTORY_WORKFLOW: "/admin/history-client-appointment",
  ARCHIVED_WORKFLOW: "/admin/archived-client-appointment",
  CREATE_CLIENT: "/admin/settings/create-client",
};

export const DEV_ACCOUNTS = [
  "xin.guo+admin@telecare.com.au",
  "chenze.li@telecare.com.au",
  "lina.xu@telecare.com.au",
  "wbhhs@telecare.com.au",
  "cqhhs@telecare.com.au",
];

export const GEO_RESTRICTION_BYPASS_WHITELIST = [
  "jude.j@telecare.com.au",
  "dawn.r@telecare.com.au",
  "elgen.s@telecare.com.au",
  "elva.s@telecare.com.au",
  "lou.f@telecare.com.au",
  "jam.d@telecare.com.au",
];

export const CORE_PLUS_GENDER_OPTIONS = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];

export const GENDER_OPTIONS = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Intersex or Indeterminate", value: "Intersex or Indeterminate" },
  { label: "Not Stated", value: "Not Stated" },
];
